import React from "react";

const VARIANT_CLASS = {
  main: "dashboard-main-text",
  supporting: "dashboard-supporting-text",
  metadata: "dashboard-metadata-text",
  "table-header": "dashboard-table-header",
  "table-body": "dashboard-table-body",
  "table-body-emphasis": "dashboard-table-body-emphasis",
  "table-meta": "dashboard-table-meta",
  nav: "dashboard-nav-text",
  tab: "dashboard-tab-text",
  pagination: "dashboard-pagination-text",
  "modal-title": "dashboard-modal-title",
  "modal-body": "dashboard-modal-body",
  "modal-meta": "dashboard-modal-meta",
  alert: "dashboard-alert-text",
  "alert-supporting": "dashboard-alert-supporting-text",
  "metric-large": "dashboard-metric-large",
  "metric-medium": "dashboard-metric-medium",
  "metric-small": "dashboard-metric-small",
  "metric-micro": "dashboard-metric-micro",
  "autocomplete-highlight": "dashboard-autocomplete-highlight",
};

/**
 * Dashboard Typography System — body, table, nav, modal, metrics, alerts.
 * Used in admin, business, and customer logged-in areas.
 */
const DashboardText = ({ variant = "main", as: Tag = "span", children, className = "" }) => {
  const styleClass = VARIANT_CLASS[variant] || VARIANT_CLASS.main;

  return <Tag className={`${styleClass} ${className}`.trim()}>{children}</Tag>;
};

export default DashboardText;
